import React from 'react';

import PlanSelector from '../components/Merchant/PlanSelector';
import SecureAddCard from '../components/Merchant/SecureAddCard';

// Customer-facing Subscription page (sidebar item under Metrics).
const SubscriptionPage = () => (
  <div className="content">
    <div style={{ maxWidth: 860, margin: '0 auto' }}>
      <h3 className="title" style={{ marginBottom: 6 }}>Subscription</h3>
      <p style={{ opacity: 0.75, marginBottom: 20 }}>View your current plan and upgrade or downgrade anytime.</p>
      <PlanSelector />
      <SecureAddCard />
    </div>
  </div>
);

export default SubscriptionPage;
